import React from 'react'
import ReactDOM from 'react-dom'
import './css/index.scss'
import CushionDesigner from './CushionDesigner.js'
import { BrowserRouter } from 'react-router-dom'
import generateNewStore from './js/store.js'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
import 'tippy.js/dist/tippy.css'

let store = generateNewStore()

ReactDOM.render(
  <Provider store={store}>
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
    <BrowserRouter>
      <CushionDesigner />
    </BrowserRouter>
  </Provider>,
  document.getElementById('cushion-designer-root'),
)
